function stripHtml(source: string) {
  return source.replace(/<[^>]+>/g, ' ')
}

function stripMarkdown(source: string) {
  return source
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '$1')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1')
    .replace(/^\s{0,3}(#{1,6})\s+/gm, '')
    .replace(/^\s*([-*+]|\d+\.)\s+/gm, '')
    .replace(/^>\s?/gm, '')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/_([^_]+)_/g, '$1')
    .replace(/~~([^~]+)~~/g, '$1')
    .replace(/\|/g, ' ')
}

export function toPlainText(source: unknown) {
  const text = String(source || '')
  return stripMarkdown(stripHtml(text)).replace(/\s+/g, ' ').trim()
}

export function toPlainExcerpt(source: unknown, maxLength = 160, fallback = '') {
  const text = toPlainText(source)
  if (!text) {
    return fallback
  }
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}
